import { FileUpload } from 'primeng/fileupload';
import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChild,
  ChangeDetectionStrategy
} from '@angular/core';

@Component({
  selector: 'app-fileuploader',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.Eager,
  templateUrl: './fileuploader.component.html',
})
export class FileUploaderComponent {
  @Input() acceptedFileTypes: string = '';
  @Input() maxFileSize: number = 1024 * 1024 * 10;
  @Input() fileLimit: number = 1;
  @Input() auto: boolean = false;
  @Input() disabled: boolean = false;

  @Output() onUpload = new EventEmitter<[any, FileUpload]>();

  @ViewChild(FileUpload) fileUploader!: FileUpload;

  constructor() {}

  upload(event: any, fileUploader: FileUpload) {
    this.onUpload.emit([event, fileUploader]);
  }

  refresh() {
    this.fileUploader.fileLimit = ++this.fileLimit;
    this.fileUploader.cd.markForCheck();
    this.fileUploader.cd.detectChanges();
  }
}
